import { render, staticRenderFns } from "./DTMoney.vue?vue&type=template&id=2c9ba41a&"
import script from "./DTMoney.vue?vue&type=script&lang=js&"
export * from "./DTMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports